export const OVERALL_PERFORMANCE_SUBTITLE_INPUT_REQUEST = 'OVERALL_PERFORMANCE_SUBTITLE_INPUT_REQUEST';
export const OVERALL_PERFORMANCE_SUBTITLE_INPUT_SUCCESS = 'OVERALL_PERFORMANCE_SUBTITLE_INPUT_SUCCESS';
export const OVERALL_PERFORMANCE_SUBTITLE_INPUT_FAIL = 'OVERALL_PERFORMANCE_SUBTITLE_INPUT_FAIL';

